import clsx from "clsx";
import { useEffect, useState, useRef } from "react";
import classes from "./Sidebar.module.css";

import { Input, Text } from "components/common";
import { Logo } from "images";
import { useAppContext } from "ContextProvider/ContextProvider";
import { RiEdit2Line, RiDeleteBin6Line } from "react-icons/ri";
import { HiOutlineDownload } from "react-icons/hi";
import { FaCheck, FaTimes } from "react-icons/fa";
import { db, deleteChatsByChatId, exportChatById } from "db";
import { toast } from "react-toastify";

const SingleCharacter = ({
  chat,
  icon,
  isActive,
  onClick,
  identifier,
  lastUpdated,
}) => {
  const { myTheme } = useAppContext();
  const [isEditing, setIsEditing] = useState(false);
  const [editedValue, setEditedValue] = useState(chat || "");

  // Create a ref for the input element
  const inputRef = useRef(null);

  const formatLastUpdated = (timestamp) => {
    if (!timestamp) return "";
    const date = new Date(timestamp);
    const now = new Date();
    const diffInSeconds = Math.floor((now - date) / 1000);

    if (diffInSeconds < 60) return "Just now";
    if (diffInSeconds < 3600) return `${Math.floor(diffInSeconds / 60)}m ago`;
    if (diffInSeconds < 86400)
      return `${Math.floor(diffInSeconds / 3600)}h ago`;
    if (diffInSeconds < 604800)
      return `${Math.floor(diffInSeconds / 86400)}d ago`;
    return date.toLocaleDateString();
  };

  const handleSave = () => {
    localStorage.setItem(`sticky-header-${identifier}`, editedValue);
    db.chatMetadata.update(identifier, { heading: editedValue });
    setIsEditing(false);
  };

  const handleCancel = () => {
    setEditedValue(chat);
    setIsEditing(false);
  };

  const handleDownload = async () => {
    await exportChatById(identifier);
  };

  useEffect(() => {
    // Update editedValue when chat prop changes
    setEditedValue(chat);
  }, [chat]);

  useEffect(() => {
    // Close the editing state if the chat is not active
    if (!isActive) {
      setIsEditing(false);
    }
  }, [isActive]);

  useEffect(() => {
    // Focus the input when editing starts
    if (isEditing && inputRef.current) {
      inputRef.current.focus();
    }
  }, [isEditing]);

  return (
    <div
      className={clsx(classes.character, isActive && classes.activeCharacter)}
      onClick={onClick}
    >
      {/* {icon ? (
        <img src={icon} alt="character" className={classes.characterIcon} />
      ) : (
        <span className={classes.systemLogo}>
          <Logo color={myTheme.color} />
        </span>
      )} */}

      <div className={classes.chatInfo}>
        {isEditing ? (
          <Input
            sm
            type="text"
            className={classes.editInput}
            value={editedValue}
            setValue={setEditedValue}
            ref={inputRef} // Attach the ref to the input
          />
        ) : (
          <>
            <Text primitive200 sm className={classes.characterName}>
              {editedValue || "New Chat"}
            </Text>
            <Text xs primitive400 className={classes.lastUpdated}>
              {formatLastUpdated(lastUpdated)}
            </Text>
          </>
        )}
      </div>

      <div className={classes.actionContainer}>
        {isEditing ? (
          <>
            <button className={classes.actionButton} onClick={handleSave}>
              <FaCheck className={classes.checkIcon} />
            </button>
            <button className={classes.actionButton} onClick={handleCancel}>
              <FaTimes className={classes.closeIcon} />
            </button>
          </>
        ) : (
          <>
            <button
              className={classes.actionButton}
              onClick={(e) => {
                e.stopPropagation();
                setIsEditing(true);
              }}
            >
              <RiEdit2Line />
            </button>
            <button
              className={classes.actionButton}
              onClick={(e) => {
                e.stopPropagation();
                deleteChatsByChatId(identifier);
              }}
            >
              <RiDeleteBin6Line />
            </button>
            <button
              className={classes.actionButton}
              onClick={(e) => {
                e.stopPropagation();
                handleDownload();
              }}
            >
              <HiOutlineDownload />
            </button>
          </>
        )}
      </div>
    </div>
  );
};

export default SingleCharacter;
